/* globals XDomainRequest */
export default function uploadWithProgress(url, data = {}, onProgress) {
  return new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest()
    if (data.withCredentials) {
      if ('withCredentials' in xhr) {
        xhr.open(data.method || 'POST', url, true)
      } else if ('undefined' !== typeof XDomainRequest) {
        xhr = new XDomainRequest()
        xhr.open(data.method || 'POST', url)
      } else {
        xhr = null
        reject(new Error('CORS not supported'))
      }
    } else {
      xhr.open(data.method || 'POST', url, true)
    }
    if (xhr) {
      Object.keys(data.headers || {}).forEach(headerKey => {
        xhr.setRequestHeader(headerKey, data.headers[headerKey])
      })
      xhr.withCredentials = data.withCredentials || false
      xhr.onload = event => resolve(event.target.responseText)
      xhr.onerror = reject
      if (xhr.upload && onProgress) xhr.upload.onprogress = onProgress
      xhr.send(data.body)
    }
  })
}
